/** @format */

import React from 'react';
import heart from '../images/main/Heart.png';
import star from '../images/main/Star.png';
export const Heart = () => {
	return (
		<div className="heart">
			<img src={heart} alt="Heart" />
		</div>
	);
};
export const Star = () => {
	return (
		<div className="star">
			<img src={star} alt="star" />
		</div>
	);
};
